


export const sections = {
                A: {
                    title: 'Validating New Ideas',
                    coreService: {
                        name: 'Viability Assessment',
                        description: 'Comprehensive analysis including market research, competitive analysis, financial projections, risk assessment, and growth strategy.'
                    },
                    prompt: 'What is your immediate next step?',
                    options: [
                        { id: 'a1', trigger: 'Need to attract investors', service: 'Pitch Deck Design' },
                        { id: 'a2', trigger: 'Ready to test with users', service: 'MVP Development' },
                        { id: 'a3', trigger: 'Want to validate market demand', service: 'Landing Page Creation' },
                        { id: 'a4', trigger: 'Need to establish your brand', service: 'Brand Identity & Positioning' },
                        { id: 'a5', trigger: 'Planning your launch', service: 'Go-to-Market Strategy' }
                    ]
                },
                B: {
                    title: 'Revenue & Market Growth',
                    coreService: {
                        name: 'Digital Marketing Strategy',
                        description: 'Comprehensive strategy including SEO optimization, content marketing, social media management, PPC advertising, and email marketing campaigns.'
                    },
                    prompt: 'What challenges are you facing?',
                    options: [
                        { id: 'b1', trigger: 'Manual processes slowing growth', service: 'Business Process Automation' },
                        { id: 'b2', trigger: 'Struggling with customer management', service: 'CRM Integration & Setup' },
                        { id: 'b3', trigger: 'Need better performance insights', service: 'Data Analytics & Reporting' },
                        { id: 'b4', trigger: 'Traffic but low conversions', service: 'Conversion Rate Optimization' },
                        { id: 'b5', trigger: 'Customer retention issues', service: 'Customer Journey Mapping' }
                    ]
                },
                C: {
                    title: 'Digital Modernization',
                    coreService: {
                        name: 'Digital Transformation',
                        description: 'Comprehensive digital transformation strategy including technology modernization, process optimization, change management, and implementation roadmap.'
                    },
                    prompt: 'Primary project focus',
                    options: [
                        { id: 'c1', trigger: 'Website redesign or rebuild', service: 'UI/UX Research & Design + Development' },
                        { id: 'c2', trigger: 'Mobile experience needed', service: 'Mobile App Development' },
                        { id: 'c3', trigger: 'Custom business software', service: 'Enterprise Software Development' },
                        { id: 'c4', trigger: 'Outdated systems update', service: 'Legacy System Modernization' },
                        { id: 'c5', trigger: 'Cloud migration required', service: 'Cloud Migration Strategy' }
                    ],
                    secondaryPrompt: 'Supporting services',
                    secondaryOptions: [
                        { id: 'c6', trigger: 'System integration needed', service: 'API Development & Integration' },
                        { id: 'c7', trigger: 'Accessibility compliance', service: 'Accessibility Audit & Compliance' },
                        { id: 'c8', trigger: 'Team training required', service: 'Digital Training & Change Management' },
                        { id: 'c9', trigger: 'Security concerns', service: 'Cybersecurity Assessment' },
                        { id: 'c10', trigger: 'Phased implementation', service: 'Digital Strategy Roadmap' }
                    ]
                },
                D: {
                    title: 'Scaling & Expansion',
                    coreService: {
                        name: 'Viability Assessment + Ongoing Support',
                        description: 'Strategic growth planning combined with ongoing partnership for sustainable, scalable business development.'
                    },
                    prompt: 'What are your growth priorities?',
                    options: [
                        { id: 'd1', trigger: 'Executive strategic guidance', service: 'Strategic Consulting & Advisory' },
                        { id: 'd2', trigger: 'New markets or regions', service: 'Market Expansion Planning' },
                        { id: 'd3', trigger: 'Technology limiting growth', service: 'Technology Stack Assessment' },
                        { id: 'd4', trigger: 'Competitive intelligence needed', service: 'Competitive Intelligence' },
                        { id: 'd5', trigger: 'Innovation culture building', service: 'Innovation Workshops' }
                    ]
                }
            };